<script>
  import Ads from "./cAds.svelte";
  import Cocopeat from "./Cocopeat.svelte";
  import Coconutfiber from "./CoconutFiber.svelte";
  import Coconutsugar from "./CoconutSugar.svelte";
  import Coconutdesiccated from "./CoconutDesiccated.svelte";
  import Copra from "./Copra.svelte";
  import Bajakah from "./Bajakah.svelte";
  import Betelnut from "./Betelnut.svelte";
  import Nipa from "./Nipa.svelte";
  import Kratom from "./Kratom.svelte";
  import Shrimp from "./Shrimp.svelte";
  import OthersCommodity from "./OthersCommodity.svelte";
  import MainCommodity from "./MainCommodity.svelte";
  import Commodity from "./Commodity.svelte";
  import Robusta from "./Robusta.svelte";
  import Arabica from "./Arabica.svelte";
  import ArabicaFermented from "./ArabicaFermented.svelte";
  import ArabicaWildCivet from "./ArabicaWildCivet.svelte";

  let commoditySelected = "1";

  function commodityOnClick(i) {
    commoditySelected = i;
    console.log("comodity " + commoditySelected);
    isModalOpen = true
    console.log("isModalOpen "+ isModalOpen)
  }

  $: commoditySelected;

  let commodityOthersSelected = "1";

  function commodityOthersOnClick(i) {
    commodityOthersSelected = i;
    console.log("comodity " + commodityOthersSelected);
  }

  $: commodityOthersSelected;

  let commodityOtherActive = false;
  let active = "";
  let show = "";
  let commodityCode = 1;
  let isModalOpen = false;

  function commodityOtherActiveFunc() {
    commodityCode = 2;
    active = "active";
    show = "show";
    commodityOtherActive = true;
    console.log("selected other " + active);
  }

  function commodityOtherInActiveFunc() {
    active = "";
    show = "";
    commodityCode = 1;
    commodityOtherActive = true;
    console.log("selected other " + active);
  }

  $: active;
  $: show;
  $: commodityOtherActive;
  $: isModalOpen;
</script>

<!-- ======= Menu Section ======= -->
<section id="menu" class="menu">
  <div class="container-fluid" data-aos="fade-up">
    <div class="section-title text-center mt-120">
      <h5
        class="sub-title mb-15 ctext-navy"
        data-aos="fade-up"
        data-aos-duration="3000"
      >
        Our Commodities
      </h5>
      <h2 class="title mt-2" data-aos="fade-up" data-aos-duration="3000">
        Commodities You May Love
      </h2>
    </div>

    <ul
      class="nav nav-tabs d-flex justify-content-center"
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <li class="nav-item" on:click={() => commodityOtherInActiveFunc()}>
        <a
          class="nav-link active show"
          data-bs-toggle="tab"
          data-bs-target="#menu-starters"
          on:click={() => commodityOtherInActiveFunc()}
        >
          <h4 on:click={() => commodityOtherInActiveFunc()}>Coconut</h4>
        </a>
      </li>
      <!-- End tab nav item -->

      
      <li class="nav-item" on:click={() => commodityOtherActiveFunc()}>
        <a
          class="nav-link"
          data-bs-toggle="tab"
          data-bs-target="#menu-lunch"
          on:click={() => commodityOtherActiveFunc()}
        >
          <h4 on:click={() => commodityOtherActiveFunc()}>Coffee</h4>
        </a>
      </li>
      <!-- End tab nav item -->
    </ul>

    <div class="tab-content">
      <div class="tab-pane fade active show" id="menu-starters">
        <div class="tab-header text-center">
          <p>The Commodity</p>
          <h3>Coconut</h3>
        </div>

        <div class="row mt-40 mx-20">
          <div
            class="col-lg-3"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <div class="single-project">
              <a href="#commodity-item" on:click={() => commodityOnClick("1")}>
                <div class="project-image">
                  <img
                    src="assets/images/project/coconutsemihusk.jpg"
                    alt="Project"
                  />
                </div>
                <div class="project-content">
                  <a
                    class="project-title page-scroll"
                    on:click={() => commodityOnClick("1")}
                    >Semi Husked Coconut</a
                  >
                </div>
              </a>
            </div>
          </div>
          <div
            class="col-lg-3"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <div class="single-project">
              <a href="#commodity-item" on:click={() => commodityOnClick("2")}>
                <div class="project-image">
                  <img src="assets/images/project/cocopeat.jpg" alt="Project" />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item"
                    on:click={() => commodityOnClick("2")}>Cocopeat</a
                  >
                </div>
              </a>
            </div>
          </div>
          <div
            class="col-lg-3"
            data-aos="flip-right"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <div class="single-project">
              <a href="#commodity-item" on:click={() => commodityOnClick("3")}>
                <div class="project-image">
                  <img
                    src="assets/images/project/coconutfiber.jpg"
                    alt="Project"
                  />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item"
                    on:click={() => commodityOnClick("3")}>Coconut Fiber</a
                  >
                </div>
              </a>
            </div>
          </div>
          <!-- <div
            class="col-lg-4"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <div class="single-project" on:click={() => commodityOnClick("4")}>
              <a href="#commodity-item" on:click={() => commodityOnClick("4")}>
                <div class="project-image">
                  <img
                    src="assets/images/project/coconutsugar.jpg"
                    alt="Project"
                  />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item"
                    on:click={() => commodityOnClick("4")}>Coconut Sugar</a
                  >
                </div>
              </a>
            </div>
          </div> -->
          <div
            class="col-lg-3"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <div class="single-project" on:click={() => commodityOnClick("5")}>
              <a href="#commodity-item" on:click={() => commodityOnClick("5")}>
                <div class="project-image">
                  <img
                    src="assets/images/project/desiccatedcoconut.jpg"
                    alt="Project"
                  />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item"
                    on:click={() => commodityOnClick("5")}>Desiccated Coconut</a
                  >
                </div>
              </a>
            </div>
          </div>
          <!-- <div
            class="col-lg-4"
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          >
            <div class="single-project" on:click={() => commodityOnClick("6")}>
              <a href="#commodity-item" on:click={() => commodityOnClick("6")}>
                <div class="project-image">
                  <img src="assets/images/project/copra.png" alt="Project" />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item"
                    on:click={() => commodityOnClick("6")}>Copra</a
                  >
                </div>
              </a>
            </div>
          </div> -->
        </div>

        {#if commoditySelected == "1"}
          <Ads />
        {:else if commoditySelected == "2"}
          <Cocopeat />
        {:else if commoditySelected == "3"}
          <Coconutfiber />
        {:else if commoditySelected == "4"}
          <Coconutsugar />
        {:else if commoditySelected == "5"}
          <Coconutdesiccated />
        {:else if commoditySelected == "6"}
          <Copra />
        {:else}
          <Ads />
        {/if}
      </div>
      <!-- End Starter Menu Content -->

      
      <!-- End Breakfast Menu Content -->

      <div class="tab-pane fade" id="menu-lunch">
        <div class="tab-header text-center">
          <p>The Commodity</p>
          <h3>Coffee</h3>
        </div>

        <div class="row mt-40 mx-20">
          <div class="col-lg-3">
            <div class="single-project">
              <a
                href="#commodity-item-others"
                on:click={() => commodityOthersOnClick("1")}
              >
                <div class="project-image">
                  <img src="assets/images/project/coffeerobusta.jpg" alt="Project" />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item-others"
                    on:click={() => commodityOthersOnClick("1")}>Robusta</a
                  >
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="single-project">
              <a
                href="#commodity-item-others"
                on:click={() => commodityOthersOnClick("2")}
              >
                <div class="project-image">
                  <img
                    src="assets/images/project/coffeearabica.jpg"
                    alt="Project"
                  />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item-others"
                    on:click={() => commodityOnClick("2")}>Arabica Gayo</a
                  >
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="single-project">
              <a
                href="#commodity-item-others"
                on:click={() => commodityOthersOnClick("3")}
              >
                <div class="project-image">
                  <img src="assets/images/project/coffeefermentasi.jpg" alt="Project" />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item-others"
                    on:click={() => commodityOthersOnClick("3")}>Arabica Gayo Fermented</a
                  >
                </div>
              </a>
            </div>
          </div>
          <div class="col-lg-3">
            <div
              class="single-project"
              on:click={() => commodityOthersOnClick("4")}
            >
              <a
                href="#commodity-item-others"
                on:click={() => commodityOthersOnClick("4")}
              >
                <div class="project-image">
                  <img
                    src="assets/images/project/coffeeluwakliar.jpg"
                    alt="Project"
                  />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item-others"
                    on:click={() => commodityOthersOnClick("4")}>Arabica Gayo Wild Civet</a
                  >
                </div>
              </a>
            </div>
          </div>
          <!-- <div class="col-lg-4">
            <div
              class="single-project"
              on:click={() => commodityOthersOnClick("5")}
            >
              <a
                href="#commodity-item-others"
                on:click={() => commodityOthersOnClick("5")}
              >
                <div class="project-image">
                  <img src="assets/images/project/shrimp.jpg" alt="Project" />
                </div>
                <div class="project-content">
                  <a
                    class="project-title"
                    href="#commodity-item-others"
                    on:click={() => commodityOthersOnClick("5")}
                    >Vannamei Shrimp</a
                  >
                </div>
              </a>
            </div>
          </div> -->
        </div>
        {#if commodityOthersSelected == "1"}
          <Robusta />
        {:else if commodityOthersSelected == "2"}
          <Arabica/>
        {:else if commodityOthersSelected == "3"}
          <ArabicaFermented />
        {:else if commodityOthersSelected == "4"}
          <ArabicaWildCivet />
        {:else if commodityOthersSelected == "5"}
          <Shrimp />
        {:else}
          <Robusta />
        {/if}
      </div>
    </div>
    <!-- End Lunch Menu Content -->
  </div>
</section>

<!-- End Menu Section -->
<style>
  /*--------------------------------------------------------------
# Set main reusable colors and fonts using CSS variables
# Learn more about CSS variables at https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_custom_properties
--------------------------------------------------------------*/
  /* Fonts */
  :root {
    --font-default: "Open Sans", system-ui, -apple-system, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol",
      "Noto Color Emoji";
    --font-primary: "Amatic SC", sans-serif;
    --font-secondary: "Inter", sans-serif;
  }

  /* Colors */
  :root {
    --color-default: #212529;
    --color-primary: #ce1212;
    --color-secondary: #37373f;
  }

  /* Smooth scroll behavior */
  :root {
    scroll-behavior: smooth;
  }

  /*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
  a {
    text-decoration: none;
  }

  a:hover {
    color: #74bc44;
    text-decoration: none;
  }

  @import url("https://fonts.googleapis.com/css?family=Barlow:300,400,500,600,700|Hind:400,500,600,700|Quattrocento:400,700");
  body {
    font-family: "Hind", sans-serif;
    font-weight: normal;
    font-style: normal;
    color: #646464;
  }

  * {
    margin: 0;
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  img {
    max-width: 100%;
  }

  a:focus,
  input:focus,
  textarea:focus,
  button:focus {
    text-decoration: none;
    outline: none;
  }

  a:focus,
  a:hover {
    text-decoration: none;
  }

  i,
  span,
  a {
    display: inline-block;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  ul,
  li {
    font-family: "Quattrocento", serif;
    font-weight: 700;
    color: #121619;
    margin: 0px;
  }

  h1 {
    font-size: 60px;
  }

  h2 {
    font-size: 36px;
  }

  h3 {
    font-size: 28px;
  }

  h4 {
    font-size: 22px;
  }

  h5 {
    font-size: 18px;
  }

  h6 {
    font-size: 16px;
  }

  .circle-img {
    border-radius: 25%;
  }

  /*--------------------------------------------------------------
# Menu Section
--------------------------------------------------------------*/
  .menu .nav-tabs {
    border: 0;
  }

  .menu .nav-link {
    margin: 0 10px;
    padding: 10px 5px;
    transition: 0.3s;
    color: #74bc44;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 0;
    border-bottom: 2px solid #b6b6bf;
  }

  .menu .nav-link .active {
    margin: 0 10px;
    padding: 10px 5px;
    transition: 0.3s;
    color: #74bc44;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 0;
    border-bottom: 2px solid #01264c;
  }

  .menu ul {
    margin-top: 40px;
  }

  .menu .active {
    margin: 0 10px;
    padding: 10px 5px;
    transition: 0.3s;
    color: #74bc44;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 0;
    border-bottom: 2px solid #74bc44;
  }

  .menu .nav-link:hover {
    margin: 0 10px;
    padding: 10px 5px;
    transition: 0.3s;
    color: #74bc44;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 0;
    border-bottom: 2px solid #74bc44;
  }

  @media (max-width: 575px) {
    .menu .nav-link {
      margin: 0 10px;
      padding: 10px 0;
    }
  }

  .menu .nav-link i {
    padding-right: 15px;
    font-size: 48px;
  }

  .menu .nav-link h4 {
    font-size: 18px;
    font-weight: 800;
    margin: 0;
  }

  @media (max-width: 575px) {
    .menu .nav-link h4 {
      font-size: 16px;
    }
  }

  .menu .nav-link h4:hover {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    color: #74bc44;
  }

  .menu .active h4 {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
    color: #74bc44;
  }
  /* .menu .nav-link:hover {
  color: #74bc44;
} */

  .menu .nav-link .active {
    color: #74bc44;
    border-color: #74bc44;
  }

  .green {
    color: #74bc44;
    border-color: #74bc44;
  }

  .menu .tab-content {
    padding: 0px 0px;
  }

  .menu .tab-content .tab-header {
    padding: 30px 0;
  }

  .menu .tab-content .tab-header p {
    font-size: 14px;
    text-transform: uppercase;
    color: #676775;
    margin-bottom: 0;
  }

  .menu .tab-content .tab-header h3 {
    font-size: 36px;
    font-weight: 600;
    color: #74bc44;
  }

  .menu .tab-content .menu-item {
    -moz-text-align-last: center;
    text-align-last: center;
    margin-top: 30px;
  }

  .menu .tab-content .menu-item .menu-img {
    padding: 0 60px;
    margin-bottom: 15px;
  }

  .menu .tab-content .menu-item h4 {
    font-size: 22px;
    font-weight: 700;
    color: var(--color-secondary);
    font-weight: 30px;
    margin-bottom: 5px;
  }

  .menu .tab-content .menu-item .ingredients {
    font-family: var(--font-secondary);
    color: #8d8d9b;
    margin-bottom: 5px;
  }

  .menu .tab-content .menu-item .price {
    font-size: 21px;
    font-weight: 700;
    margin-top: -10px;
    color: #74bc44;
  }

  .ctext-navy {
    color: #01264c;
  }

  .single-project {
    padding: 0px 10px;
  }
</style>
